import { lazy } from "react";

export const LandingSixthScreenAsync = lazy(() => import("./LandingSixthScreen"));
